<template>
	<PopMenu class="menu-button"
		:options="options"
	>
		<template #button="{ onClick, }">
			<TeamingButton2
				:size="size"
				:type="type"
				:disabled="disabled"
				:active="active"
				:focused="focused"
				:borderless="borderless"
				:destructive="destructive"
				@click="onClick"
			>
				<template #default>
					<slot></slot>
				</template>
				<template #right-icon>
					<FontAwesomeIcon :icon="[ `fas`, `caret-down` ]" />
				</template>
			</TeamingButton2>
		</template>
	</PopMenu>
</template>

<script>

import { TeamingButtonSize, TeamingButtonType } from "@teaming/common-enums";

import PopMenu, { makeOption } from "../PopMenu.vue";
import TeamingButton2 from "./TeamingButton2.vue";

export const makeMenuButtonOption = makeOption;

export default {
	name: "MenuButton",
	components: {
		PopMenu,
		TeamingButton2,
	},
	props: {
		size: {
			type: String,
			default: TeamingButtonSize.MEDIUM,
			validator: value => TeamingButtonSize.includes( value ),
		},
		type: {
			type: String,
			default: TeamingButtonType.PRIMARY,
			validator: value => TeamingButtonType.includes( value ),
		},
		//
		// states
		//
		disabled: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		focused: {
			type: Boolean,
			default: false,
		},
		//
		// variants
		//
		borderless: {
			type: Boolean,
			default: false,
		},
		destructive: {
			type: Boolean,
			default: false,
		},
		/** @see PopMenu::makeOption */
		options: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped></style>
